import { _lcs } from "../i18n";

/**
 * The GridJS `language` block, translated.
 *
 * Every list screen configures the same eight strings and differs only in what
 * it counts ("… von 42 Benutzern") and what it says when it finds nothing. Kept
 * in one place so a new language means one set of entries in the dictionary
 * rather than eight identical ones.
 *
 * @param {string} results         Unit for the pagination summary, already
 *                                 translated (e.g. _lcs( "Benutzern" )).
 * @param {string} [noRecordsFound] Empty-table message; defaults to a generic one.
 * @returns {object} GridJS language config.
 */
export function gridLanguage( results, noRecordsFound = null )
{
    return {
        search : { placeholder : _lcs( "Suchen …" ) },
        pagination : {
            previous : _lcs( "Zurück" ),
            next     : _lcs( "Weiter" ),
            showing  : _lcs( "Zeige" ),
            of       : _lcs( "von" ),
            to       : _lcs( "bis" ),
            results  : results
        },
        loading        : _lcs( "Lädt …" ),
        noRecordsFound : noRecordsFound || _lcs( "Keine Einträge gefunden" ),
        error          : _lcs( "Fehler beim Laden der Daten" )
    };
}
